/**
 * VEL-2183 — Limit 1 of each product on Simple Bundles / Infinite Options selects.
 * SB injects #simple-bundles-io-options outside the product <form>, so listen on document.
 *
 * Multi-choice selections default to empty ("Please select an option"). Single-option
 * rows (e.g. fixed Product 1/2) stay selected. Already-chosen products are disabled
 * in other dropdowns. Does not prefill the first unique product across choices.
 */
(function () {
  const LIMIT_FORM = 'form[action*="/cart/add"][data-limit-1-per-product="true"]';
  let userTouched = false;

  function getForm() {
    return document.querySelector(LIMIT_FORM);
  }

  function getSelects() {
    const root = document.querySelector("#simple-bundles-io-options");
    if (!root) return [];
    return Array.from(root.querySelectorAll("select")).filter((el) => {
      const name = String(el.name || "").toLowerCase();
      const id = String(el.id || "").toLowerCase();
      if (name === "id") return false;
      if (id === "product-select" || id.startsWith("product-select-")) return false;
      return true;
    });
  }

  function getAddButton(form) {
    return (
      form?.querySelector("[data-add-to-cart]") ||
      form?.closest(".product-form")?.querySelector("[data-add-to-cart]")
    );
  }

  function realOptions(select) {
    return Array.from(select.options).filter((option) => option.value);
  }

  function isShopperVisible(select) {
    // offsetParent is null for display:none (and ancestors). Hidden rows must not
    // be cleared to Please select — the shopper cannot fill them.
    return Boolean(select.offsetParent);
  }

  function keepOrSelectFirst(select) {
    const options = realOptions(select);
    if (!options.length) return;
    if (!select.value || !options.some((option) => option.value === select.value)) {
      select.value = options[0].value;
    }
  }

  function resetToPleaseSelect(selects) {
    selects.forEach((select) => {
      const options = realOptions(select);
      // Fixed/single-option rows, or rows hidden by CSS, must stay selected so ATC
      // is not blocked after the shopper only fills the visible multi-choice dropdowns.
      if (options.length <= 1 || !isShopperVisible(select)) {
        keepOrSelectFirst(select);
        return;
      }
      const emptyOption = select.querySelector('option[value=""]');
      if (emptyOption) select.value = "";
    });
  }

  function selectionState(selects) {
    const values = selects.map((select) => String(select.value || "").trim());
    const filled = values.filter(Boolean);
    return {
      isValid:
        values.length > 0 &&
        filled.length === values.length &&
        filled.length === new Set(filled).size,
    };
  }

  function syncAddButton(selects) {
    const form = getForm();
    const button = getAddButton(form);
    if (!button || button.hasAttribute("data-disabled-flag")) return;
    if (selectionState(selects).isValid) {
      button.removeAttribute("disabled");
    } else {
      button.setAttribute("disabled", "disabled");
    }
  }

  function enforce() {
    if (!getForm()) return;
    const selects = getSelects();
    if (selects.length < 2) return;

    // Until the shopper interacts, clear SB/theme prefills on multi-choice
    // dropdowns so they show "Please select an option". Keep single-option rows.
    if (!userTouched) {
      resetToPleaseSelect(selects);
    } else {
      // Keep first occurrence; clear later duplicates back to please-select.
      const used = new Set();
      selects.forEach((select) => {
        const current = select.value;
        if (!current) return;
        if (used.has(current)) {
          const emptyOption = select.querySelector('option[value=""]');
          if (emptyOption) select.value = "";
          return;
        }
        used.add(current);
      });
    }

    // Disable options already taken in other selects
    selects.forEach((select) => {
      const taken = selects
        .filter((other) => other !== select)
        .map((other) => other.value)
        .filter(Boolean);
      Array.from(select.options).forEach((option) => {
        if (!option.value) return;
        option.disabled = taken.includes(option.value);
      });
    });

    syncAddButton(selects);
  }

  document.addEventListener("change", (event) => {
    if (!event.target?.closest?.("#simple-bundles-io-options")) return;
    userTouched = true;
    enforce();
  });

  const start = () => {
    enforce();
    let n = 0;
    const id = setInterval(() => {
      enforce();
      if (++n >= 20) clearInterval(id);
    }, 300);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
